import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Focus = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M3.75 8V5.75a2 2 0 0 1 2-2H8M3.75 16v2.25a2 2 0 0 0 2 2H8m8-16.5h2.25a2 2 0 0 1 2 2V8m0 8v2.25a2 2 0 0 1-2 2H16M15.25 12a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M5.75 4.5c-.69 0-1.25.56-1.25 1.25V8A.75.75 0 0 1 3 8V5.75A2.75 2.75 0 0 1 5.75 3H8a.75.75 0 0 1 0 1.5z'
          fill='currentColor'
        />
        <path
          d='M15.25 3.75A.75.75 0 0 1 16 3h2.25A2.75 2.75 0 0 1 21 5.75V8a.75.75 0 0 1-1.5 0V5.75c0-.69-.56-1.25-1.25-1.25H16a.75.75 0 0 1-.75-.75'
          fill='currentColor'
        />
        <path
          d='M3.75 15.25a.75.75 0 0 1 .75.75v2.25c0 .69.56 1.25 1.25 1.25H8A.75.75 0 0 1 8 21H5.75A2.75 2.75 0 0 1 3 18.25V16a.75.75 0 0 1 .75-.75'
          fill='currentColor'
        />
        <path
          d='M20.25 15.25A.75.75 0 0 1 21 16v2.25A2.75 2.75 0 0 1 18.25 21H16a.75.75 0 0 1 0-1.5h2.25c.69 0 1.25-.56 1.25-1.25V16a.75.75 0 0 1 .75-.75'
          fill='currentColor'
        />
        <path d='M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8' fill='currentColor' />
      </>
    )}
  </IconBase>
);
